import React, { useEffect, useState } from 'react';
import css from '@/css/module/billing.css';
import flex from '@/css/module/flex.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  SUBSCRIPTION_TAG,
  subscriptionApi,
  TSubscription,
} from '@/features/subscription/apiSlice';
import { closeReactModal, openReactModal } from '@/actions';
import UpdateReceiptsEmailModal from '@/components/billing/UpdateReceiptsEmailModal';
import { useAppDispatch } from '@/store/hooks';

export const SendReceiptsTo: React.FC<{
  subscription: TSubscription;
  hasAddress: boolean;
  cardShortName: string;
}> = ({ subscription, hasAddress, cardShortName }) => {
  const [sendReceiptsTo, setSendReceiptsTo] = useState<string>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (subscription?.sendReceiptsTo) {
      setSendReceiptsTo(subscription.sendReceiptsTo);
    }
  }, [subscription?.sendReceiptsTo]);

  const onOpenUpdateSendReceiptsToEmail = (
    existingEmail: string,
    done: F<string>,
  ) => {
    const closeModal = (isUpdated: boolean) => (email: string) => {
      dispatch(closeReactModal());
      if (isUpdated) {
        done(email);
        dispatch(subscriptionApi.util.invalidateTags([SUBSCRIPTION_TAG]));
      }
    };
    dispatch(
      openReactModal(
        <UpdateReceiptsEmailModal
          closeModal={closeModal(false)}
          onUpdated={closeModal(true)}
          existingEmail={existingEmail}
        />,
      ),
    );
  };

  if (!sendReceiptsTo || !cardShortName || !hasAddress) {
    return null;
  }

  return (
    <div className={css.section}>
      <div className={`${flex.row} ${flex.alignItemsStart}`}>
        <div className={css.billingIcon}>
          <FontAwesomeIcon icon="user-tie" />
        </div>
        <div>
          <b>Send receipts to:</b>&nbsp;{sendReceiptsTo}
          &nbsp;&nbsp;
          <span
            onClick={() =>
              onOpenUpdateSendReceiptsToEmail(sendReceiptsTo, setSendReceiptsTo)
            }
            className="link"
          >
            Edit
          </span>
        </div>
      </div>
    </div>
  );
};
